import { IContentType } from '~src/spacesPlatform/models/ContentTypes';
import { Order } from '~src/ts/helpers/Order';
import { OrderKeys } from '~src/ts/models/OrderKeys';

// This is currently only used for the defaultOrder from what I can tell
export const ConnectedApplicationContentType: IContentType = {
  name: 'connectedApplication',
  filterKeys: [],
  canShowFilterPanel: false,
  orderKeys: [
    OrderKeys.name
  ],
  defaultOrder: [Order.asc(OrderKeys.name)]
};
